var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export function getSupportedChains() {
    return window.cosmostation.cosmos.request({ method: 'cos_supportedChainNames' });
}
export function getActivatedChains() {
    return window.cosmostation.cosmos.request({ method: 'cos_activatedChainNames' });
}
export function getAccount(chainName) {
    return window.cosmostation.cosmos.request({ method: 'cos_account', params: { chainName: chainName } });
}
export function requestAccount(chainName) {
    return window.cosmostation.cosmos.request({ method: 'cos_requestAccount', params: { chainName: chainName } });
}
export function addChain(chain) {
    return window.cosmostation.cosmos.request({ method: 'cos_addChain', params: __assign({}, chain) });
}
export function signAmino(chainName, doc, options) {
    return window.cosmostation.cosmos.request({
        method: 'cos_signAmino',
        params: { chainName: chainName, doc: doc, isEditMemo: !!(options === null || options === void 0 ? void 0 : options.memo), isEditFee: !!(options === null || options === void 0 ? void 0 : options.fee), gasRate: options === null || options === void 0 ? void 0 : options.gasRate },
    });
}
export function signDirect(chainName, doc, options) {
    return window.cosmostation.cosmos.request({
        method: 'cos_signDirect',
        params: { chainName: chainName, doc: doc, isEditMemo: !!(options === null || options === void 0 ? void 0 : options.memo), isEditFee: !!(options === null || options === void 0 ? void 0 : options.fee), gasRate: options === null || options === void 0 ? void 0 : options.gasRate },
    });
}
export function sendTransaction(chainName, txBytes, mode) {
    return window.cosmostation.cosmos.request({
        method: 'cos_sendTransaction',
        params: { chainName: chainName, txBytes: txBytes, mode: mode },
    });
}
export var autoSign = {
    set: function (chainName, duration) {
        return window.cosmostation.cosmos.request({
            method: 'cos_setAutoSign',
            params: { chainName: chainName, duration: duration },
        });
    },
    get: function (chainName) {
        return window.cosmostation.cosmos.request({
            method: 'cos_getAutoSign',
            params: { chainName: chainName },
        });
    },
    delete: function (chainName) {
        return window.cosmostation.cosmos.request({
            method: 'cos_deleteAutoSign',
            params: { chainName: chainName },
        });
    },
};
export function addCW20Tokens(chainName, tokens) {
    return window.cosmostation.cosmos.request({
        method: 'cos_addTokensCW20',
        params: { chainName: chainName, tokens: tokens },
    });
}
export function getCW20TokenBalance(chainName, contractAddress, address) {
    return window.cosmostation.cosmos.request({
        method: 'cos_getBalanceCW20',
        params: { chainName: chainName, contractAddress: contractAddress, address: address },
    });
}
export function getCW20TokenInfo(chainName, contractAddress) {
    return window.cosmostation.cosmos.request({
        method: 'cos_getTokenInfoCW20',
        params: { chainName: chainName, contractAddress: contractAddress },
    });
}
export function onAccountChanged(handler) {
    return window.cosmostation.cosmos.on('accountChanged', handler);
}
export function offAccountChanged(event) {
    window.cosmostation.cosmos.off(event);
}
export var SEND_TRANSACTION_MODE = {
    UNSPECIFIED: 0,
    BLOCK: 1,
    SYNC: 2,
    ASYNC: 3,
};
export var COSMOS_TYPE = {
    BASIC: '',
    ETHERMINT: 'ETHERMINT',
};
